export default __webpack_public_path__ + "static/flyerBackThumb2-981a881bc690700f4e4b0792067e4d47.jpg";